import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import KeyShares from './KeyShares'

const ASSURANCES = [
  'They never see anything in your account.',
  'They cannot start a recovery on their own.',
  'You can invite them now and send later.'
]

const RecoveryIntro = props => (
  <Paper elevation={3} component='div' className='recovery-intro'>
    <Box component='div'>
      <Typography variant='h4' gutterBottom>Recovery contacts</Typography>
      <Typography variant='body1' gutterBottom>
        Choose up to five people you trust. Each one holds a piece of a key to your account. If you
        ever lose your password, any three of them together can let you back in.
      </Typography>
      <KeyShares large />
      <Typography className='caption' variant='body2' gutterBottom>
        Three pieces unlock your account. Fewer than three open nothing at all.
      </Typography>
      <Divider />
      <Stack className='assurances' component='div'>
        {ASSURANCES.map(assurance => <Typography key={assurance} variant='body2'>{assurance}</Typography>)}
      </Stack>
    </Box>
    <Button
      disabled={props.loading}
      className='action'
      color='primary'
      onClick={props.onStart}
      variant='contained'>
      Start
    </Button>
  </Paper>
)

RecoveryIntro.propTypes = {
  onStart: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default RecoveryIntro
